// extracted by mini-css-extract-plugin
export default {"banner":"Hero_banner__-ATGK","overlay":"Hero_overlay__fA-QC","h-c-white":"Hero_h-c-white__0dWnC","h-c-black":"Hero_h-c-black__WzA+S","h-c-yellow":"Hero_h-c-yellow__gdiW3"};